angular.module('impactx.quota').controller('QuotaListCtrl', [
    'selectedListItems',
    'dataGen',
    '$route',
    'ToastService',
    QuotaListCtrl
]);

function QuotaListCtrl(selectedListItems, dataGen, $route, ToastService) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewQuota'
        },
        {
            label: "synchronize",
            action: synchronize,
            type: 'dialogaction',
            condition: canSync,
        },
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/quota/templates/quotalist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/quota/list',
        id: "quotalist",
        mainAction: {id: "new", link: "#/quota/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "quota/" + selectedListItems.getFirstSelectedId();
    }

    function canSync() {
        return selectedListItems.isAnySelected() && selectedListItems.getSelectedItems().every(function (item) {
            return item.canSync === "1";
        });
    }

    function synchronize() {
        dataGen.postAsForm({}, {ids: selectedListItems.getSelectedIds()}, "/quota/synchronize").then(function(data) {
            ToastService.openStandardToast(data.trns.syncMessage);
            $route.reload();
        });
    }
}